import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Carousel } from 'primereact/carousel';
import BaseCard from './BaseCard.jsx';
import { useNavigate } from 'react-router-dom';
import IconRocket from '../images/IconRocket.jsx';
import { getStatusBadgeClass } from '../../utils/project.js';

const OrganizationProjectsCarousel = ({ className, items, page, orgId }) => {
    const navigate = useNavigate();

    const projectItemTemplate = (project) => {
        return (
            <div className='mr-4'>
                <BaseCard className='mr-4 my-4 p-0 overflow-hidden relative rounded-2xl min-h-[80px] shadow-mildSubtleRight'>
                    <div className='flex items-center justify-center bg-theme1-pinkGray p-4 rounded-b-3xl relative'>
                        <div className='py-4'>
                            <IconRocket className='stroke-theme1-gold1 w-10 h-10' />
                        </div>
                        <div
                            className={`absolute bottom-[-7px] right-5 px-3 py-1 rounded-md text-[9px] font-bold text-white capitalize ${getStatusBadgeClass(project.status)}`}
                        >
                            {project.status}
                        </div>
                    </div>
                    <div className='p-4'>
                        <div className='text-theme1-primary font-bold text-md mt-2'>{project.name}</div>
                        <div className='mt-4'>
                            <div
                                className='rounded-4xl border border-theme1-primary text-theme1-primary text-sm font-bold py-1 text-center'
                                onClick={() => navigate('/projects/' + project.id)}
                            >
                                View
                            </div>
                        </div>
                    </div>
                </BaseCard>
            </div>
        );
    };

    return (
        <div className={twMerge('', className)}>
            <Carousel
                value={items}
                numScroll={1}
                numVisible={2}
                itemTemplate={projectItemTemplate}
                showNavigators={false}
                circular={false}
                showIndicators
                page={page || 0}
            />
        </div>
    );
};

export default OrganizationProjectsCarousel;
